function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/**
    @external BaseClass
    @see https://github.com/d3plus/d3plus-common#BaseClass
*/

import { extent, max, min, range as d3Range, ticks as d3Ticks } from "d3-array";
import { timeFormat, timeFormatDefaultLocale } from "d3-time-format";
import * as scales from "d3-scale";
import { select as _select } from "d3-selection";
import { transition } from "d3-transition";
import { assign, attrize, configPrep, BaseClass, closest, constant, elem } from "d3plus-common";
import { colorDefaults } from "d3plus-color";
import { formatAbbreviate, formatDate, formatLocale } from "d3plus-format";
import * as shapes from "d3plus-shape";
import { rtl as detectRTL, TextBox, textWrap } from "d3plus-text";
import { default as date } from "./date.js";
import { default as locale } from "./locale.js";
var floorPow = function floorPow(d) {
  return Math.pow(10, Math.floor(Math.log10(d)));
};

/**
 * Calculates ticks from a given scale (negative and/or positive)
 * @param {scale} scale A d3-scale object
 * @private
 */
function calculateTicks(scale) {
  var useData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var tickScale = scales.scaleSqrt().domain([10, 400]).range([10, 50]);
  var negativeRange = scale.range();
  var size = Math.abs(negativeRange[1] - negativeRange[0]);
  var step = Math.floor(size / tickScale(size));
  if (this._scale === "time" && this._data && this._data.length) {
    var dataExtent = extent(this._data);
    var distance = this._data.reduce(function (n, d, i, arr) {
      if (i) {
        var dist = Math.abs(d - arr[i - 1]);
        if (dist < n) n = dist;
      }
      return n;
    }, Infinity);
    var newStep = Math.round((dataExtent[1] - dataExtent[0]) / distance);
    step = useData ? min([step * 2, newStep]) : min([step, newStep]);
  }
  var ticks = scale.ticks(step);
  if (this._data.length) {
    var dataNumbers = this._data.map(Number);
    ticks = ticks.filter(function (t) {
      return dataNumbers.includes(+t);
    });
  }
  var domain = this._data.length ? extent(this._data) : scale.domain();
  var diff = ticks.reduce(function (n, d, i, arr) {
    if (i && n < d - arr[i - 1]) n = d;
    return n;
  }, 0);
  if (!ticks.map(Number).includes(+domain[0])) {
    if (ticks[0] - domain[0] < diff) ticks.shift();
    ticks.unshift(domain[0]);
  }
  if (!ticks.map(Number).includes(+domain[1])) {
    if (domain[1] - ticks[ticks.length - 1] < diff) ticks.pop();
    ticks.push(domain[1]);
  }
  return ticks;
}

/**
    @class Axis
    @extends external:BaseClass
    @desc Creates an SVG scale based on an array of data.
*/
var Axis = /*#__PURE__*/function (_BaseClass) {
  _inherits(Axis, _BaseClass);
  var _super = _createSuper(Axis);
  /**
      @memberof Axis
      @desc Invoked when creating a new class instance, and sets any default parameters.
      @private
  */
  function Axis() {
    var _this;
    _classCallCheck(this, Axis);
    _this = _super.call(this);
    _this._align = "middle";
    _this._barConfig = {
      "stroke": "#999",
      "stroke-width": 1
    };
    _this._data = [];
    _this._domain = [0, 10];
    _this._duration = 600;
    _this._gridConfig = {
      "stroke": "#eee",
      "stroke-width": 1
    };
    _this._gridLog = false;
    _this._height = 400;
    _this._labelOffset = false;
    _this._labelRotation = false;
    _this.orient("bottom");
    _this._outerBounds = {
      width: 0,
      height: 0,
      x: 0,
      y: 0
    };
    _this._padding = 5;
    _this._paddingInner = 0.1;
    _this._paddingOuter = 0.1;
    _this._scale = "linear";
    _this._scalePadding = 0.5;
    _this._shape = "Line";
    _this._shapeConfig = {
      fill: "#999",
      height: function height(d) {
        return d.tick ? 8 : 0;
      },
      label: function label(d) {
        return d.text;
      },
      labelBounds: function labelBounds(d) {
        return d.labelBounds;
      },
      labelConfig: {
        fontColor: "#999",
        fontFamily: new TextBox().fontFamily(),
        fontResize: false,
        fontSize: constant(14),
        padding: 0,
        textAnchor: function textAnchor() {
          var rtl = detectRTL(_this._select.node());
          return _this._orient === "left" ? rtl ? "start" : "end" : _this._orient === "right" ? rtl ? "end" : "start" : _this._labelRotation ? _this._orient === "bottom" ? "end" : "start" : "middle";
        },
        verticalAlign: function verticalAlign() {
          return _this._orient === "bottom" ? "top" : _this._orient === "top" ? "bottom" : "middle";
        }
      },
      r: function r(d) {
        return d.tick ? 4 : 0;
      },
      stroke: "#999",
      strokeWidth: 1,
      width: function width(d) {
        return d.tick ? 8 : 0;
      }
    };
    _this._tickSize = 8;
    _this._tickSuffix = "normal";
    _this._tickUnit = 0;
    _this._timeLocale = undefined;
    _this._titleClass = new TextBox();
    _this._titleConfig = {
      fontColor: colorDefaults.dark,
      fontSize: 12,
      textAnchor: "middle"
    };
    _this._width = 400;
    return _this;
  }

  /**
      @memberof Axis
      @desc Sets positioning for the axis bar.
      @param {D3Selection} *bar*
      @private
  */
  _createClass(Axis, [{
    key: "_barPosition",
    value: function _barPosition(bar) {
      var _this$_position = this._position,
        height = _this$_position.height,
        x = _this$_position.x,
        y = _this$_position.y,
        opposite = _this$_position.opposite,
        offset = this._margin[opposite],
        position = ["top", "left"].includes(this._orient) ? this._outerBounds[y] + this._outerBounds[height] - offset : this._outerBounds[y] + offset;
      var x1mod = this._scale === "band" ? this._d3Scale.step() - this._d3Scale.bandwidth() : this._scale === "point" ? this._d3Scale.step() * this._d3Scale.padding() : 0;
      var x2mod = this._scale === "band" ? this._d3Scale.step() : this._scale === "point" ? this._d3Scale.step() * this._d3Scale.padding() : 0;
      var sortedDomain = (this._d3ScaleNegative ? this._d3ScaleNegative.domain() : []).concat(this._d3Scale ? this._d3Scale.domain() : []).sort(function (a, b) {
        return a - b;
      });
      bar.call(attrize, this._barConfig).attr("".concat(x, "1"), this._getPosition(sortedDomain[0]) - x1mod).attr("".concat(x, "2"), this._getPosition(sortedDomain[sortedDomain.length - 1]) + x2mod).attr("".concat(y, "1"), position).attr("".concat(y, "2"), position);
    }

    /**
        @memberof Axis
        @desc Returns the scale's domain, taking into account negative and positive log scales.
        @private
    */
  }, {
    key: "_getDomain",
    value: function _getDomain() {
      var ticks = [];
      if (this._d3ScaleNegative) ticks = this._d3ScaleNegative.domain();
      if (this._d3Scale) ticks = ticks.concat(this._d3Scale.domain());
      var domain = ["band", "ordinal", "point"].includes(this._scale) ? ticks : extent(ticks);
      return ticks[0] > ticks[1] ? domain.reverse() : domain;
    }

    /**
        @memberof Axis
        @desc Returns a value's scale position, taking into account negative and positive log scales.
        @param {Number|String} *d*
        @private
    */
  }, {
    key: "_getPosition",
    value: function _getPosition(d) {
      return this._scale === "log" && d === 0 ? (this._d3Scale || this._d3ScaleNegative).range()[this._d3Scale ? 0 : 1] : (this._scale === "log" && d < 0 ? this._d3ScaleNegative || function () {
        return 0;
      } : this._d3Scale)(d);
    }

    /**
        @memberof Axis
        @desc Returns the scale's range, taking into account negative and positive log scales.
        @private
    */
  }, {
    key: "_getRange",
    value: function _getRange() {
      var ticks = [];
      if (this._d3ScaleNegative) ticks = this._d3ScaleNegative.range();
      if (this._d3Scale) ticks = ticks.concat(this._d3Scale.range());
      return ticks[0] > ticks[1] ? extent(ticks).reverse() : extent(ticks);
    }

    /**
        @memberof Axis
        @desc Returns the scale's labels, taking into account negative and positive log scales.
        @private
    */
  }, {
    key: "_getLabels",
    value: function _getLabels() {
      var labels = [];
      if (this._d3ScaleNegative) labels = labels.concat(calculateTicks.bind(this)(this._d3ScaleNegative, false));
      if (this._d3Scale) labels = labels.concat(calculateTicks.bind(this)(this._d3Scale, false));
      return labels;
    }

    /**
        @memberof Axis
        @desc Returns the scale's ticks, taking into account negative and positive log scales.
        @private
    */
  }, {
    key: "_getTicks",
    value: function _getTicks() {
      if (["band", "ordinal", "point", "time"].includes(this._scale) && this._data && this._data.length < this._width / 4) {
        return this._scale === "time" ? this._data.map(date) : this._data;
      }
      var ticks = [];
      if (this._d3ScaleNegative) ticks = ticks.concat(calculateTicks.bind(this)(this._d3ScaleNegative, true));
      if (this._d3Scale) ticks = ticks.concat(calculateTicks.bind(this)(this._d3Scale, true));
      return ticks;
    }

    /**
        @memberof Axis
        @desc Sets positioning for the grid lines.
        @param {D3Selection} *lines*
        @private
    */
  }, {
    key: "_gridPosition",
    value: function _gridPosition(lines) {
      var last = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$_position2 = this._position,
        height = _this$_position2.height,
        x = _this$_position2.x,
        y = _this$_position2.y,
        opposite = _this$_position2.opposite,
        offset = this._margin[opposite],
        position = ["top", "left"].includes(this._orient) ? this._outerBounds[y] + this._outerBounds[height] - offset : this._outerBounds[y] + offset,
        scale = last ? this._lastScale || this._getPosition.bind(this) : this._getPosition.bind(this),
        size = ["top", "left"].includes(this._orient) ? offset : -offset,
        xDiff = this._scale === "band" ? this._d3Scale.bandwidth() / 2 : 0,
        xPos = function xPos(d) {
          return scale(d.id) + xDiff;
        };
      lines.call(attrize, this._gridConfig).attr("".concat(x, "1"), xPos).attr("".concat(x, "2"), xPos).attr("".concat(y, "1"), position).attr("".concat(y, "2"), last ? position : position + size);
    }

    /**
        @memberof Axis
        @desc Renders the current Axis to the page. If a *callback* is specified, it will be called once the legend is done drawing.
        @param {Function} [*callback* = undefined]
        @chainable
    */
  }, {
    key: "render",
    value: function render(callback) {
      var _this2 = this,
        _this$_outerBounds;
      /**
       * Creates an SVG element to contain the axis if none
       * has been specified using the "select" method.
       */
      if (this._select === void 0) {
        this.select(_select("body").append("svg").attr("width", "".concat(this._width, "px")).attr("height", "".concat(this._height, "px")).node());
      }
      var timeLocale = this._timeLocale || locale[this._locale] || locale["en-US"];
      timeFormatDefaultLocale(timeLocale).format();

      /**
       * Declares some commonly used variables.
       */
      var _this$_position3 = this._position,
        width = _this$_position3.width,
        height = _this$_position3.height,
        x = _this$_position3.x,
        y = _this$_position3.y,
        horizontal = _this$_position3.horizontal,
        opposite = _this$_position3.opposite,
        clipId = "d3plus-Axis-clip-".concat(this._uuid),
        flip = ["top", "left"].includes(this._orient),
        p = this._padding,
        parent = this._select,
        rangeOuter = [p, this["_".concat(width)] - p],
        t = transition().duration(this._duration);
      var tickValue = this._shape === "Circle" ? this._shapeConfig.r : this._shape === "Rect" ? this._shapeConfig[width] : this._shapeConfig.strokeWidth;
      var tickGet = typeof tickValue !== "function" ? function () {
        return tickValue;
      } : tickValue;

      /**
       * Zeros out the margins for re-calculation.
       */
      var margin = this._margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      };
      var labels, range, ticks;

      /**
       * Constructs the tick formatter function.
       */
      var tickFormat = this._tickFormat ? this._tickFormat : function (d) {
        if (isNaN(d) || ["band", "ordinal", "point"].includes(_this2._scale)) {
          return d;
        } else if (_this2._scale === "time") {
          return formatDate(d, (_this2._data || labels).map(date), timeFormat).replace(/^Q/g, timeLocale.quarter);
        } else if (_this2._scale === "linear" && _this2._tickSuffix === "smallest") {
          var _locale = _typeof(_this2._locale) === "object" ? _this2._locale : formatLocale[_this2._locale];
          var separator = _locale.separator,
            suffixes = _locale.suffixes;
          var suff = d >= 1000 ? suffixes[_this2._tickUnit + 8] : "";
          var tick = d / Math.pow(10, 3 * _this2._tickUnit);
          var number = formatAbbreviate(tick, _locale, ",.".concat(tick.toString().length, "r"));
          return "".concat(number).concat(separator).concat(suff);
        } else {
          return formatAbbreviate(d, _this2._locale);
        }
      };

      /**
       * (Re)calculates the internal d3 scale
       * @param {} newRange
       */
      function setScale() {
        var _this3 = this;
        var newRange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._range;
        /**
         * Calculates the internal "range" array to use, including
         * fallbacks if not specified with the "range" method.
         */
        range = newRange ? newRange.slice() : [undefined, undefined];
        var minRange = rangeOuter[0],
          maxRange = rangeOuter[1];
        if (this._range) {
          if (this._range[0] !== undefined) minRange = this._range[0];
          if (this._range[this._range.length - 1] !== undefined) maxRange = this._range[this._range.length - 1];
        }
        if (range[0] === undefined || range[0] < minRange) range[0] = minRange;
        if (range[1] === undefined || range[1] > maxRange) range[1] = maxRange;
        var sizeInner = maxRange - minRange;
        if (this._scale === "ordinal" && this._domain.length > range.length) {
          if (newRange === this._range) {
            var buckets = this._domain.length + 1;
            range = d3Range(buckets).map(function (d) {
              return range[0] + sizeInner * (d / (buckets - 1));
            }).slice(1, buckets);
            range = range.map(function (d) {
              return d - range[0] / 2;
            });
          } else {
            var _buckets = this._domain.length;
            var size = range[1] - range[0];
            range = d3Range(_buckets).map(function (d) {
              return range[0] + size * (d / (_buckets - 1));
            });
          }
        } else if (newRange === this._range) {
          var tickScale = scales.scaleSqrt().domain([10, 400]).range([10, 50]);
          var domain = this._scale === "time" ? this._domain.map(date) : this._domain;
          var scaleTicks = d3Ticks(domain[0], domain[1], Math.floor(sizeInner / tickScale(sizeInner)));
          labels = (this._labels ? this._scale === "time" ? this._labels.map(date) : this._labels : scaleTicks).slice();
          var _buckets2 = labels.length;
          if (_buckets2) {
            var pad = Math.ceil(sizeInner / _buckets2 / 2);
            range = [range[0] + pad, range[1] - pad];
          }
        }

        /**
         * Sets up the initial d3 scale, using this._domain and the
         * previously defined range variable.
         */
        var scale = "scale".concat(this._scale.charAt(0).toUpperCase()).concat(this._scale.slice(1));
        this._d3Scale = scales[scale]().domain(this._scale === "time" ? this._domain.map(date) : this._domain).range(range);
        if (this._d3Scale.padding) this._d3Scale.padding(this._scalePadding);
        if (this._d3Scale.paddingInner) this._d3Scale.paddingInner(this._paddingInner);
        if (this._d3Scale.paddingOuter) this._d3Scale.paddingOuter(this._paddingOuter);

        /**
         * Constructs a separate "negative only" scale for logarithmic
         * domains, as they cannot pass zero.
         */
        this._d3ScaleNegative = null;
        if (this._scale === "log") {
          var _domain = this._d3Scale.domain();
          if (_domain[0] === 0) {
            var smallestNumber = min([min(this._data), Math.abs(_domain[1])]);
            _domain[0] = smallestNumber === 0 || smallestNumber === 1 ? 1e-6 : smallestNumber <= 1 ? floorPow(smallestNumber) : 1;
            if (_domain[1] < 0) _domain[0] *= -1;
          } else if (_domain[_domain.length - 1] === 0) {
            var _smallestNumber = min([min(this._data), Math.abs(_domain[0])]);
            _domain[_domain.length - 1] = _smallestNumber === 0 || _smallestNumber === 1 ? 1e-6 : _smallestNumber <= 1 ? floorPow(_smallestNumber) : 1;
            if (_domain[0] < 0) _domain[_domain.length - 1] *= -1;
          }
          var _range = this._d3Scale.range();
          if (_domain[0] < 0 && _domain[_domain.length - 1] < 0) {
            this._d3ScaleNegative = this._d3Scale.copy().domain(_domain).range(_range);
            this._d3Scale = null;
          } else if (_domain[0] > 0 && _domain[_domain.length - 1] > 0) {
            this._d3Scale.domain(_domain).range(_range);
          } else {
            var percentScale = scales.scaleLinear().domain(_domain).range([0, 1]);
            var leftPercentage = percentScale(0);
            var zero = leftPercentage * (_range[1] - _range[0]);
            var smallestPositive = min([min(this._data.filter(function (d) {
              return d >= 0;
            })), Math.abs(_domain[1])]);
            var smallestNegative = min([min(this._data.filter(function (d) {
              return d < 0 || Object.is(d, -0);
            })), Math.abs(_domain[0])]);
            var smallestPosPow = smallestPositive === 0 ? 1e-6 : smallestPositive <= 1 ? floorPow(smallestPositive) : 1;
            var smallestNegPow = smallestNegative === 0 ? -1e-6 : smallestNegative <= 1 ? floorPow(smallestNegative) : 1;
            var _smallestNumber2 = min([smallestPosPow, smallestNegPow]);
            this._d3ScaleNegative = this._d3Scale.copy();
            (_domain[0] < 0 ? this._d3Scale : this._d3ScaleNegative).domain([_domain[0] < 0 ? _smallestNumber2 : -_smallestNumber2, _domain[1]]).range([_range[0] + zero, _range[1]]);
            (_domain[0] < 0 ? this._d3ScaleNegative : this._d3Scale).domain([_domain[0], _domain[0] < 0 ? -_smallestNumber2 : _smallestNumber2]).range([_range[0], _range[0] + zero]);
          }
        }

        /**
         * Determines the of values array to use
         * for the "ticks" and the "labels"
         */
        ticks = (this._ticks ? this._scale === "time" ? this._ticks.map(date) : this._ticks : (this._d3Scale ? this._d3Scale.ticks : this._d3ScaleNegative.ticks) ? this._getTicks() : this._domain).slice();
        labels = (this._labels ? this._scale === "time" ? this._labels.map(date) : this._labels : (this._d3Scale ? this._d3Scale.ticks : this._d3ScaleNegative.ticks) ? this._getLabels() : ticks).slice();
        if (this._scale === "log") {
          var tens = labels.filter(function (t, i) {
            return !i || i === labels.length - 1 || Math.abs(t).toString().charAt(0) === "1" && (_this3._d3Scale ? t !== -1 : t !== 1);
          });
          if (tens.length > 2) {
            labels = tens;
          } else if (labels.length >= 10) {
            labels = labels.filter(function (t) {
              return t % 5 === 0 || tickFormat(t).substr(-1) === "1";
            });
          }
          if (labels.includes(-1) && labels.includes(1) && labels.some(function (d) {
            return d > 10 || d < 10;
          })) {
            labels.splice(labels.indexOf(-1), 1);
          }
        }
        if (this._scale === "time") {
          ticks = ticks.map(Number);
          labels = labels.map(Number);
        }
        ticks = ticks.sort(function (a, b) {
          return _this3._getPosition(a) - _this3._getPosition(b);
        });
        labels = labels.sort(function (a, b) {
          return _this3._getPosition(a) - _this3._getPosition(b);
        });

        /**
         * Get the smallest suffix.
         */
        if (this._scale === "linear" && this._tickSuffix === "smallest") {
          var suffixes = labels.filter(function (d) {
            return d >= 1000;
          });
          if (suffixes.length > 0) {
            var _min = Math.min.apply(Math, _toConsumableArray(suffixes));
            var i = 1;
            while (i && i < 7) {
              var n = Math.pow(10, 3 * i);
              if (_min / n >= 1) {
                this._tickUnit = i;
                i += 1;
              } else {
                break;
              }
            }
          }
        }

        /**
         * Removes ticks when they overlap other ticks.
         */
        var pixels = [];
        this._availableTicks = ticks;
        ticks.forEach(function (d, i) {
          var s = tickGet({
            id: d,
            tick: true
          }, i);
          if (_this3._shape === "Circle") s *= 2;
          var t = _this3._getPosition(d);
          if (!pixels.length || Math.abs(closest(t, pixels) - t) > s * 2) pixels.push(t);else pixels.push(false);
        });
        ticks = ticks.filter(function (d, i) {
          return pixels[i] !== false;
        });
        this._visibleTicks = ticks;
      }
      setScale.bind(this)();

      /**
       * Calculates the space available for a given label.
       * @param {Object} datum
       */
      function calculateSpace(datum) {
        var diff = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var i = datum.i,
          position = datum.position;
        if (this._scale === "band") {
          return this._d3Scale.bandwidth();
        } else {
          var prevPosition = i - diff < 0 ? textData.length === 1 || !this._range ? rangeOuter[0] : (position - textData[i + diff].position) / 2 - position : position - (position - textData[i - diff].position) / 2;
          var prevSpace = Math.abs(position - prevPosition);
          var nextPosition = i + diff > textData.length - 1 ? textData.length === 1 || !this._range ? rangeOuter[1] : (position - textData[i - diff].position) / 2 - position : position - (position - textData[i + diff].position) / 2;
          var nextSpace = Math.abs(position - nextPosition);
          return min([prevSpace, nextSpace]) * 2;
        }
      }

      /**
       * Pre-calculates the size of the title, if defined, in order
       * to adjust the internal margins.
       */
      if (this._title) {
        var _this$_titleConfig = this._titleConfig,
          _fontFamily = _this$_titleConfig.fontFamily,
          _fontSize = _this$_titleConfig.fontSize,
          lineHeight = _this$_titleConfig.lineHeight;
        var titleWrap = textWrap().fontFamily(typeof _fontFamily === "function" ? _fontFamily() : _fontFamily).fontSize(typeof _fontSize === "function" ? _fontSize() : _fontSize).lineHeight(typeof lineHeight === "function" ? lineHeight() : lineHeight).width(range[range.length - 1] - range[0] - p * 2).height(this["_".concat(height)] - this._tickSize - p * 2);
        var lines = titleWrap(this._title).lines.length;
        margin[this._orient] = lines * titleWrap.lineHeight() + p;
      }
      var hBuff = this._shape === "Circle" ? typeof this._shapeConfig.r === "function" ? this._shapeConfig.r({
          tick: true
        }) : this._shapeConfig.r : this._shape === "Rect" ? typeof this._shapeConfig[height] === "function" ? this._shapeConfig[height]({
          tick: true
        }) : this._shapeConfig[height] : this._tickSize,
        wBuff = tickGet({
          tick: true
        });
      if (typeof hBuff === "function") hBuff = max(ticks.map(hBuff));
      if (this._shape === "Rect") hBuff /= 2;
      if (typeof wBuff === "function") wBuff = max(ticks.map(wBuff));
      if (this._shape !== "Circle") wBuff /= 2;
      var _this$_shapeConfig$la = this._shapeConfig.labelConfig,
        fontFamily = _this$_shapeConfig$la.fontFamily,
        fontSize = _this$_shapeConfig$la.fontSize;

      /**
       * Calculates the space each label would take up, given
       * the provided this._space size.
       */
      var textData = labels.map(function (d, i) {
        var fF = typeof fontFamily === "function" ? fontFamily(d, i) : fontFamily,
          fS = typeof fontSize === "function" ? fontSize(d, i) : fontSize,
          position = _this2._getPosition(d);
        var lineHeight = _this2._shapeConfig.lineHeight ? _this2._shapeConfig.lineHeight(d, i) : fS * 1.4;
        return {
          d: d,
          i: i,
          fF: fF,
          fS: fS,
          lineHeight: lineHeight,
          position: position
        };
      });

      /**
       * Calculates the text wrapping and size of a given textData object.
       * @param {Object} datum
       */
      function calculateLabelSize(datum) {
        var d = datum.d,
          i = datum.i,
          fF = datum.fF,
          fS = datum.fS,
          rotate = datum.rotate,
          space = datum.space;
        var h = rotate ? "width" : "height",
          w = rotate ? "height" : "width";
        var wSize = min([this._maxSize, this._width]);
        var hSize = min([this._maxSize, this._height]);
        var wrap = textWrap().fontFamily(fF).fontSize(fS).lineHeight(this._shapeConfig.lineHeight ? this._shapeConfig.lineHeight(d, i) : undefined);
        wrap[w](horizontal ? space : wSize - hBuff - p - this._margin.left - this._margin.right);
        wrap[h](horizontal ? hSize - hBuff - p - this._margin.top - this._margin.bottom : space);
        var res = wrap(tickFormat(d));
        res.lines = res.lines.filter(function (d) {
          return d !== "";
        });
        res.width = res.lines.length ? Math.ceil(max(res.widths)) + fS / 4 : 0;
        if (res.width % 2) res.width++;
        res.height = res.lines.length ? Math.ceil(res.lines.length * wrap.lineHeight()) + fS / 4 : 0;
        if (res.height % 2) res.height++;
        return res;
      }

      /** Calculates label offsets */
      function calculateOffset() {
        var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var offset = 0;
        arr.forEach(function (datum) {
          var prev = arr[datum.i - 1];
          var h = datum.rotate && horizontal || !datum.rotate && !horizontal ? "width" : "height",
            w = datum.rotate && horizontal || !datum.rotate && !horizontal ? "height" : "width";
          if (!prev) {
            offset = 1;
          } else if (prev.position + prev[w] / 2 > datum.position - datum[w] / 2) {
            if (offset) {
              datum.offset = prev[h];
              offset = 0;
            } else offset = 1;
          }
        });
      }
      textData = textData.map(function (datum) {
        datum.rotate = _this2._labelRotation;
        datum.space = calculateSpace.bind(_this2)(datum);
        var res = calculateLabelSize.bind(_this2)(datum);
        return Object.assign(res, datum);
      });
      var offsetEnabled = this._labelOffset && textData.some(function (d) {
        return d.truncated;
      });
      if (this._labelRotation) {
        textData = textData.map(function (datum) {
          datum.rotate = true;
          var res = calculateLabelSize.bind(_this2)(datum);
          return Object.assign(datum, res);
        });
      } else if (offsetEnabled) {
        textData = textData.map(function (datum) {
          datum.space = calculateSpace.bind(_this2)(datum, 2);
          var res = calculateLabelSize.bind(_this2)(datum);
          return Object.assign(datum, res);
        });
        calculateOffset.bind(this)(textData);
      }

      /**
       * "spillover" will contain the pixel spillover of the first and last label,
       * and then adjust the scale range accordingly.
       */
      var spillover = [0, 0];
      for (var index = 0; index < 2; index++) {
        var datum = textData[index ? textData.length - 1 : 0];
        if (!datum) break;
        var _height = datum.height,
          position = datum.position,
          rotate = datum.rotate,
          _width = datum.width;
        var compPosition = index ? rangeOuter[1] : rangeOuter[0];
        var halfSpace = (rotate || !horizontal ? _height : _width) / 2;
        var spill = index ? position + halfSpace - compPosition : position - halfSpace - compPosition;
        spillover[index] = spill;
      }
      var first = range[0];
      var last = range[range.length - 1];
      var newRange = [first - spillover[0], last - spillover[1]];
      if (this._range) {
        if (this._range[0] !== undefined) newRange[0] = this._range[0];
        if (this._range[this._range.length - 1] !== undefined) newRange[1] = this._range[this._range.length - 1];
      }
      if (newRange[0] !== first || newRange[1] !== last) {
        setScale.bind(this)(newRange);
        textData = labels.map(function (d, i) {
          var fF = typeof fontFamily === "function" ? fontFamily(d, i) : fontFamily,
            fS = typeof fontSize === "function" ? fontSize(d, i) : fontSize,
            position = _this2._getPosition(d);
          var lineHeight = _this2._shapeConfig.lineHeight ? _this2._shapeConfig.lineHeight(d, i) : fS * 1.4;
          return {
            d: d,
            i: i,
            fF: fF,
            fS: fS,
            lineHeight: lineHeight,
            position: position
          };
        });
        textData = textData.map(function (datum) {
          datum.rotate = _this2._labelRotation;
          datum.space = calculateSpace.bind(_this2)(datum, offsetEnabled ? 2 : 1);
          var res = calculateLabelSize.bind(_this2)(datum);
          return Object.assign(res, datum);
        });
        calculateOffset.bind(this)(textData);
      }
      var labelHeight = max(textData, function (t) {
        return t.height;
      }) || 0;
      this._labelRotation = horizontal && this._labelRotation === undefined ? textData.some(function (datum) {
        var i = datum.i,
          height = datum.height,
          position = datum.position,
          truncated = datum.truncated;
        var prev = textData[i - 1];
        return truncated || i && prev.position + prev.height / 2 > position - height / 2;
      }) : this._labelRotation;
      var globalOffset = this._labelOffset ? max(textData, function (d) {
        return d.offset || 0;
      }) : 0;
      textData.forEach(function (datum) {
        return datum.offset = datum.offset ? globalOffset : 0;
      });
      var tBuff = this._shape === "Line" ? 0 : hBuff;
      var bounds = this._outerBounds = (_this$_outerBounds = {}, _defineProperty(_this$_outerBounds, height, (max(textData, function (t) {
        return Math.ceil(t[t.rotate || !horizontal ? "width" : "height"] + t.offset);
      }) || 0) + (textData.length ? p : 0)), _defineProperty(_this$_outerBounds, width, rangeOuter[rangeOuter.length - 1] - rangeOuter[0]), _defineProperty(_this$_outerBounds, x, rangeOuter[0]), _this$_outerBounds);
      bounds[height] = max([this._minSize, bounds[height]]);
      margin[this._orient] += hBuff;
      margin[opposite] = this._gridSize !== undefined ? max([this._gridSize, tBuff]) : this["_".concat(height)] - margin[this._orient] - bounds[height] - p;
      bounds[height] += margin[opposite] + margin[this._orient];
      bounds[y] = this._align === "start" ? this._padding : this._align === "end" ? this["_".concat(height)] - bounds[height] - this._padding : this["_".concat(height)] / 2 - bounds[height] / 2;
      var group = elem("g#d3plus-Axis-".concat(this._uuid), {
        parent: parent
      });
      this._group = group;
      var grid = elem("g.grid", {
        parent: group
      }).selectAll("line").data((this._gridSize !== 0 ? this._grid || this._scale === "log" && !this._gridLog ? labels : ticks : []).map(function (d) {
        return {
          id: d
        };
      }), function (d) {
        return d.id;
      });
      grid.exit().transition(t).attr("opacity", 0).call(this._gridPosition.bind(this)).remove();
      grid.enter().append("line").attr("opacity", 0).attr("clip-path", "url(#".concat(clipId, ")")).call(this._gridPosition.bind(this), true).merge(grid).transition(t).attr("opacity", 1).call(this._gridPosition.bind(this));
      var labelOnly = labels.filter(function (d, i) {
        return textData[i].lines.length && !ticks.includes(d);
      });
      var rotated = textData.some(function (d) {
        return d.rotate;
      });
      var tickData = ticks.concat(labelOnly).map(function (d) {
        var _tickConfig;
        var data = textData.find(function (td) {
          return td.d === d;
        });
        var xPos = _this2._getPosition(d);
        var space = data ? data.space : 0;
        var lines = data ? data.lines.length : 1;
        var lineHeight = data ? data.lineHeight : 1;
        var labelOffset = data && _this2._labelOffset ? data.offset : 0;
        var labelWidth = horizontal ? space : bounds.width - margin[_this2._position.opposite] - hBuff - margin[_this2._orient] + p;
        var offset = margin[opposite],
          size = (hBuff + labelOffset) * (flip ? -1 : 1),
          yPos = flip ? bounds[y] + bounds[height] - offset : bounds[y] + offset;
        var tickConfig = (_tickConfig = {
          id: d,
          labelBounds: rotated && data ? {
            x: -data.width / 2 + data.fS / 4,
            y: _this2._orient === "bottom" ? size + p + (data.width - lineHeight * lines) / 2 : size - p * 2 - (data.width + lineHeight * lines) / 2,
            width: data.width,
            height: data.height
          } : {
            x: horizontal ? -space / 2 : _this2._orient === "left" ? -labelWidth - p + size : size + p,
            y: horizontal ? _this2._orient === "bottom" ? size + p : size - p - labelHeight : -space / 2,
            width: horizontal ? space : labelWidth,
            height: horizontal ? labelHeight : space
          },
          rotate: data ? data.rotate : false,
          size: labels.includes(d) ? size : _this2._data.find(function (t) {
            return +t === d;
          }) ? Math.ceil(size / 2) : 0,
          text: labels.includes(d) ? tickFormat(d) : false,
          tick: ticks.includes(d)
        }, _defineProperty(_tickConfig, x, xPos + (_this2._scale === "band" ? _this2._d3Scale.bandwidth() / 2 : 0)), _defineProperty(_tickConfig, y, yPos), _tickConfig);
        return tickConfig;
      });
      if (this._shape === "Line") {
        tickData = tickData.concat(tickData.map(function (d) {
          var dupe = Object.assign({}, d);
          dupe[y] += d.size;
          return dupe;
        }));
      }
      new shapes[this._shape]().data(tickData).duration(this._duration).labelConfig({
        ellipsis: function ellipsis(d) {
          return d && d.length ? "".concat(d, "...") : "";
        },
        rotate: function rotate(d) {
          return d.rotate ? -90 : 0;
        }
      }).select(elem("g.ticks", {
        parent: group
      }).node()).config(configPrep.bind(this)(this._shapeConfig)).render();
      var bar = group.selectAll("line.bar").data([null]);
      bar.enter().append("line").attr("class", "bar").attr("opacity", 0).call(this._barPosition.bind(this)).merge(bar).transition(t).attr("opacity", 1).call(this._barPosition.bind(this));
      this._titleClass.data(this._title ? [{
        text: this._title
      }] : []).duration(this._duration).height(margin[this._orient]).rotate(this._orient === "left" ? -90 : this._orient === "right" ? 90 : 0).select(elem("g.d3plus-Axis-title", {
        parent: group
      }).node()).text(function (d) {
        return d.text;
      }).verticalAlign("middle").width(range[range.length - 1] - range[0]).x(horizontal ? range[0] : this._orient === "left" ? bounds.x + margin.left / 2 - (range[range.length - 1] - range[0]) / 2 : bounds.x + bounds.width - margin.right / 2 - (range[range.length - 1] - range[0]) / 2).y(horizontal ? this._orient === "bottom" ? bounds.y + bounds.height - margin.bottom : bounds.y : range[0] + (range[range.length - 1] - range[0]) / 2 - margin[this._orient] / 2).config(configPrep.bind(this)(this._titleConfig)).render();
      this._lastScale = this._getPosition.bind(this);
      if (callback) setTimeout(callback, this._duration + 100);
      return this;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the horizontal alignment to the specified value and returns the current class instance.
        @param {String} [*value* = "center"] Supports `"left"` and `"center"` and `"right"`.
        @chainable
    */
  }, {
    key: "align",
    value: function align(_) {
      return arguments.length ? (this._align = _, this) : this._align;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the axis line style and returns the current class instance.
        @param {Object} [*value*]
        @chainable
    */
  }, {
    key: "barConfig",
    value: function barConfig(_) {
      return arguments.length ? (this._barConfig = Object.assign(this._barConfig, _), this) : this._barConfig;
    }

    /**
        @memberof Axis
        @desc An array of data points, which helps determine which ticks should be shown and which time resolution should be displayed.
        @param {Array} [*value*]
        @chainable
    */
  }, {
    key: "data",
    value: function data(_) {
      return arguments.length ? (this._data = _, this) : this._data;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the scale domain of the axis and returns the current class instance.
        @param {Array} [*value* = [0, 10]]
        @chainable
    */
  }, {
    key: "domain",
    value: function domain(_) {
      return arguments.length ? (this._domain = _, this) : this._domain;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the transition duration of the axis and returns the current class instance.
        @param {Number} [*value* = 600]
        @chainable
    */
  }, {
    key: "duration",
    value: function duration(_) {
      return arguments.length ? (this._duration = _, this) : this._duration;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the grid values of the axis and returns the current class instance.
        @param {Array} [*value*]
        @chainable
    */
  }, {
    key: "grid",
    value: function grid(_) {
      return arguments.length ? (this._grid = _, this) : this._grid;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the grid config of the axis and returns the current class instance.
        @param {Object} [*value*]
        @chainable
    */
  }, {
    key: "gridConfig",
    value: function gridConfig(_) {
      return arguments.length ? (this._gridConfig = Object.assign(this._gridConfig, _), this) : this._gridConfig;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the grid behavior of the axis when scale is logarithmic and returns the current class instance.
        @param {Boolean} [*value* = false]
        @chainable
    */
  }, {
    key: "gridLog",
    value: function gridLog(_) {
      return arguments.length ? (this._gridLog = _, this) : this._gridLog;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the grid size of the axis and returns the current class instance.
        @param {Number} [*value* = undefined]
        @chainable
    */
  }, {
    key: "gridSize",
    value: function gridSize(_) {
      return arguments.length ? (this._gridSize = _, this) : this._gridSize;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the overall height of the axis and returns the current class instance.
        @param {Number} [*value* = 100]
        @chainable
    */
  }, {
    key: "height",
    value: function height(_) {
      return arguments.length ? (this._height = _, this) : this._height;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the visible tick labels of the axis and returns the current class instance.
        @param {Array} [*value*]
        @chainable
    */
  }, {
    key: "labels",
    value: function labels(_) {
      return arguments.length ? (this._labels = _, this) : this._labels;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets whether offsets will be used to position some labels further away from the axis in order to allow space for the text.
        @param {Boolean} [*value* = false]
        @chainable
     */
  }, {
    key: "labelOffset",
    value: function labelOffset(_) {
      return arguments.length ? (this._labelOffset = _, this) : this._labelOffset;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets whether whether horizontal axis labels are rotated -90 degrees.
        @param {Boolean} [*value* = false]
        @chainable
     */
  }, {
    key: "labelRotation",
    value: function labelRotation(_) {
      return arguments.length ? (this._labelRotation = _, this) : this._labelRotation;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the maximum size allowed for the space that contains the axis tick labels and title.
        @param {Number}
        @chainable
     */
  }, {
    key: "maxSize",
    value: function maxSize(_) {
      return arguments.length ? (this._maxSize = _, this) : this._maxSize;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the minimum size alloted for the space that contains the axis tick labels and title.
        @param {Number}
        @chainable
     */
  }, {
    key: "minSize",
    value: function minSize(_) {
      return arguments.length ? (this._minSize = _, this) : this._minSize;
    }

    /**
        @memberof Axis
        @desc If *orient* is specified, sets the orientation of the shape and returns the current class instance. If *orient* is not specified, returns the current orientation.
        @param {String} [*orient* = "bottom"] Supports `"top"`, `"right"`, `"bottom"`, and `"left"` orientations.
        @chainable
    */
  }, {
    key: "orient",
    value: function orient(_) {
      if (arguments.length) {
        var horizontal = ["top", "bottom"].includes(_),
          opps = {
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
          };
        this._position = {
          horizontal: horizontal,
          width: horizontal ? "width" : "height",
          height: horizontal ? "height" : "width",
          x: horizontal ? "x" : "y",
          y: horizontal ? "y" : "x",
          opposite: opps[_]
        };
        return this._orient = _, this;
      }
      return this._orient;
    }

    /**
        @memberof Axis
        @desc If called after the elements have been drawn to DOM, will returns the outer bounds of the axis content.
        @example
    {"width": 180, "height": 24, "x": 10, "y": 20}
    */
  }, {
    key: "outerBounds",
    value: function outerBounds() {
      return this._outerBounds;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the padding between each tick label to the specified number and returns the current class instance.
        @param {Number} [*value* = 10]
        @chainable
    */
  }, {
    key: "padding",
    value: function padding(_) {
      return arguments.length ? (this._padding = _, this) : this._padding;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the inner padding of band scale to the specified number and returns the current class instance.
        @param {Number} [*value* = 0.1]
        @chainable
    */
  }, {
    key: "paddingInner",
    value: function paddingInner(_) {
      return arguments.length ? (this._paddingInner = _, this) : this._paddingInner;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the outer padding of band scales to the specified number and returns the current class instance.
        @param {Number} [*value* = 0.1]
        @chainable
    */
  }, {
    key: "paddingOuter",
    value: function paddingOuter(_) {
      return arguments.length ? (this._paddingOuter = _, this) : this._paddingOuter;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the scale range (in pixels) of the axis and returns the current class instance. The given array must have 2 values, but one may be `undefined` to allow the default behavior for that value.
        @param {Array} [*value*]
        @chainable
    */
  }, {
    key: "range",
    value: function range(_) {
      return arguments.length ? (this._range = _, this) : this._range;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the scale of the axis and returns the current class instance.
        @param {String} [*value* = "linear"]
        @chainable
    */
  }, {
    key: "scale",
    value: function scale(_) {
      return arguments.length ? (this._scale = _, this) : this._scale;
    }

    /**
        @memberof Axis
        @desc Sets the "padding" property of the scale, often used in point scales.
        @param {Number} [*value* = 0.5]
        @chainable
    */
  }, {
    key: "scalePadding",
    value: function scalePadding(_) {
      return arguments.length ? (this._scalePadding = _, this) : this._scalePadding;
    }

    /**
        @memberof Axis
        @desc If *selector* is specified, sets the SVG container element to the specified d3 selector or DOM element and returns the current class instance. If *selector* is not specified, returns the current SVG container element.
        @param {String|HTMLElement} [*selector* = d3.select("body").append("svg")]
        @chainable
    */
  }, {
    key: "select",
    value: function select(_) {
      return arguments.length ? (this._select = _select(_), this) : this._select;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the tick shape constructor and returns the current class instance.
        @param {String} [*value* = "Line"]
        @chainable
    */
  }, {
    key: "shape",
    value: function shape(_) {
      return arguments.length ? (this._shape = _, this) : this._shape;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the tick style of the axis and returns the current class instance.
        @param {Object} [*value*]
        @chainable
    */
  }, {
    key: "shapeConfig",
    value: function shapeConfig(_) {
      return arguments.length ? (this._shapeConfig = assign(this._shapeConfig, _), this) : this._shapeConfig;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the tick formatter and returns the current class instance.
        @param {Function} [*value*]
        @chainable
    */
  }, {
    key: "tickFormat",
    value: function tickFormat(_) {
      return arguments.length ? (this._tickFormat = _, this) : this._tickFormat;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the tick values of the axis and returns the current class instance.
        @param {Array} [*value*]
        @chainable
    */
  }, {
    key: "ticks",
    value: function ticks(_) {
      return arguments.length ? (this._ticks = _, this) : this._ticks;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the tick size of the axis and returns the current class instance.
        @param {Number} [*value* = 5]
        @chainable
    */
  }, {
    key: "tickSize",
    value: function tickSize(_) {
      return arguments.length ? (this._tickSize = _, this) : this._tickSize;
    }

    /**
        @memberof Axis
        @desc Sets the behavior of the abbreviations when you are using linear scale. This method accepts two options: "normal" (uses formatAbbreviate to determinate the abbreviation) and "smallest" (uses suffix from the smallest tick as reference in every tick).
        @param {String} [*value* = "normal"]
        @chainable
    */
  }, {
    key: "tickSuffix",
    value: function tickSuffix(_) {
      return arguments.length ? (this._tickSuffix = _, this) : this._tickSuffix;
    }

    /**
        @memberof Axis
        @desc Defines a custom locale object to be used in time scale. This object must include the following properties: dateTime, date, time, periods, days, shortDays, months, shortMonths. For more information, you can revise [d3p.d3-time-format](https://github.com/d3/d3-time-format/blob/master/README.md#timeFormatLocale).
        @param {Object} [*value* = undefined]
        @chainable
    */
  }, {
    key: "timeLocale",
    value: function timeLocale(_) {
      return arguments.length ? (this._timeLocale = _, this) : this._timeLocale;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the title of the axis and returns the current class instance.
        @param {String} [*value*]
        @chainable
    */
  }, {
    key: "title",
    value: function title(_) {
      return arguments.length ? (this._title = _, this) : this._title;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the title configuration of the axis and returns the current class instance.
        @param {Object} [*value*]
        @chainable
    */
  }, {
    key: "titleConfig",
    value: function titleConfig(_) {
      return arguments.length ? (this._titleConfig = Object.assign(this._titleConfig, _), this) : this._titleConfig;
    }

    /**
        @memberof Axis
        @desc If *value* is specified, sets the overall width of the axis and returns the current class instance.
        @param {Number} [*value* = 400]
        @chainable
    */
  }, {
    key: "width",
    value: function width(_) {
      return arguments.length ? (this._width = _, this) : this._width;
    }
  }]);
  return Axis;
}(BaseClass);
export { Axis as default };